(() => {
  'use strict';

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const getRoot = () =>
    document.querySelector('main#main, #main, main') || document.body;

  const patchHome = (root) => {
    root.querySelectorAll('a').forEach((anchor) => {
      if (normalize(anchor.textContent).toLowerCase() === 'explore coastal soul') {
        anchor.setAttribute('href', '/pages/coastal-soul');
      }
    });
  };

  const patchReceiptsVideo = (root) => {
    const watchMore = Array.from(root.querySelectorAll('a')).find((anchor) => {
      const label = normalize(anchor.textContent).toLowerCase();
      const href = anchor.getAttribute('href') || '';
      return label === 'watch more' && /cdn\.shopify\.com\/videos\/.*\.mp4/i.test(href);
    });

    if (!watchMore) return;

    const heroContainer = watchMore.closest('[class*="ai-hero-video-container-"]');
    const player = heroContainer?.querySelector('[class*="ai-hero-video-player-"]');
    const video = player?.querySelector('video');

    if (!player || !video) return;

    player.id = 'receipts-featured-video';
    video.setAttribute('tabindex', '-1');
    watchMore.setAttribute('href', '#receipts-featured-video');
    watchMore.setAttribute('aria-controls', 'receipts-featured-video');

    if (watchMore.dataset.p2VideoBound === 'true') return;
    watchMore.dataset.p2VideoBound = 'true';

    watchMore.addEventListener('click', (event) => {
      event.preventDefault();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      player.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center'
      });

      video.muted = false;
      video.volume = 1;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }

      window.setTimeout(() => {
        try {
          video.focus({ preventScroll: true });
        } catch (_) {
          video.focus();
        }
      }, reduceMotion ? 0 : 350);
    });
  };

  const run = () => {
    const root = getRoot();
    const path = window.location.pathname.replace(/\/$/, '') || '/';

    if (path === '/') patchHome(root);
    if (path === '/pages/receipts-watch-videos') patchReceiptsVideo(root);
  };

  const schedule = () => window.requestAnimationFrame(run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  window.addEventListener('load', schedule, { once: true });
  document.addEventListener('shopify:section:load', schedule);
})();
